import React, { FC, useState } from 'react';
import { Reduction, Remise } from './iCart';
import { updateCart } from './CartAction';
import { TranslationProps, WithTranslation } from "../../contexts/TranslationContext";

interface CodeReductionProps extends TranslationProps {
  remises: Remise[];
  reduction: Reduction;
}

const RenderCodeReduction: FC<CodeReductionProps> = ({ remises, reduction, textsContent }): JSX.Element => {
  const [codeReduction, setCodeReduction] = useState<string>('');
  const [error, setError] = useState<string|undefined>(undefined);

  const applyCodeReduction = () => {
    updateCart({ code_reduction: codeReduction })
      .then(() => setError(undefined))
      .catch(err => setError(textsContent?.[err] ?? 'Error'));
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setCodeReduction(event.target.value);
  };

  const removeCodeReduction = (): void => {
    setCodeReduction('');
    updateCart({ remove_code_reduction: true });
  };

  const getDetailCodeReduction = (): string => {
    let detail = '';
    if (reduction) {
      if (reduction.remise != '0.00') {
        detail = textsContent?.['CART_PROMO_CODE_DETAIL_REMISE']?.replace('  ', Math.round(Number(reduction.remise)).toString() + '% ') ?? '';
      }
    }
    return detail;
  };

  const validText = textsContent?.['CART_PROMO_CODE_VALID'] ?? 'Code promo valide';
  const appliedText = textsContent?.['CART_PROMO_CODE_APPLIED']?.split('  ') ?? ['Code', 'appliqué'];
  const titleDelete = textsContent?.['CART_PROMO_CODE_TITLE_DELETE'] ?? 'Supprimer ce code';
  const placeholder = textsContent?.['CART_PROMO_CODE_PLACEHOLDER'] ?? 'Code promo';

  return (
    <div className=" position-relative" id="remiseCart">
      {reduction && (
        <div  className="ml-2 ">
          <div className="text-success">{validText}</div>
          <div>
            <span>
              {appliedText[0]}
              <span className="font-weight-bold"> {reduction.codePromo} </span>
              {appliedText[1]}
              <span className="ml-1">{getDetailCodeReduction()}</span>
            </span>
            <a  className="ml-1 " title={titleDelete} onClick={removeCodeReduction} href="#">
              <img src="/order/images/ic-delete.svg" height={18} alt="" />
            </a>
          </div>
        </div>
      ) || (
        <div id="containerInputRemise" className="d-flex align-items-center">
          <input
            id="remiseInput"
            title={placeholder}
            className="mr-1 ml-2 p-1"
            placeholder={placeholder}
            onChange={event => handleChange(event)}
          />
          <button id="btnSubmitRemiseInput" className="py-1 px-2" onClick={applyCodeReduction}>Ok</button>
        </div>
      )}
      {error && (
        <div style={{ color: 'red', paddingLeft:'10px', position:'absolute', top:'40px' }}>{error}</div>
      )}
    </div>
  )
};

export default WithTranslation<CodeReductionProps>(RenderCodeReduction, 'CART_TUNNEL', 'EXCEPTIONS');
